import script from "./ZCopyright.vue?vue&type=script&setup=true&lang=js"
export * from "./ZCopyright.vue?vue&type=script&setup=true&lang=js"

import "./ZCopyright.vue?vue&type=style&index=0&id=cf3bc35c&lang=scss"

const __exports__ = script;

export default __exports__